export default {
  yearsOfStudy: {
    zero: "0 yr. (No education required)",
    one: "1 yr. (e.g. 60 ECTS, Higher Vocational Education Diploma) ",
    two:
      "2 yr. (e.g. 120 ECTS, University diploma, Advanced Higher Vocational Education Diploma) ",
    three: "3 yr. (e.g. 180 ECTS, Bachelor's degree) ",
    four: "4 yr. (e.g. 240 ECTS, Master's degree, 1 year) ",
    five: "5 yr. (e.g. 300 ECTS, Master's degree, 2 years) ",
    seven: "7 yr. (e.g. 420 ECTS, Licentiate) ",
    nine: "9 yr. (e.g. 540 ECTS, Doctorate)",
  },
  educationLevels: {
    HigherVocational: "Higher Vocational Education Diploma",
    AdvancedHigherVocational: "Advanced Higher Vocational Education Diploma",
    UniversityDiploma: "University Diploma",
    Bachelor: "Bachelor's Degree",
    Master1Year: "Master's Degree (1 year)",
    Master2Year: "Master's Degree (2 years)",
    Licentiate: "Licentiate",
    Doctorate: "Doctorate",
    NoDegree: "No Degree",
  },
  educationLevelsShort: {
    HigherVocational: "Higher Vocational Education Diploma",
    AdvancedHigherVocational: "Advanced Higher Vocational Education Diploma",
    UniversityDiploma: "University Diploma",
    Bachelor: "Bachelor's Degree",
    Master1Year: "Master's Degree (1 year)",
    Master2Year: "Master's Degree (2 years)",
    Licentiate: "Licentiate",
    Doctorate: "Doctorate",
    NoDegree: "No Degree",
  },
  CompanyTalentRecuritmentStatusText: {
    Saved: "Saved",
    Invited: "Invited",
    Accepted: "Accepted",
    Removed: "Removed",
    Declined: "Declined",
    Other: "Unknown",
    Hired: "Hired",
  },
  jobOffer: {
    yesButton: "Yes, they can contact me",
    noButton: "No thanks",
    backToTheTop: "Back to the top",
  },
  laneTypes: {
    ReviewVirtaul: "Review (Required)",
    Inbox: "Inbox (Required)",
    Hired: "Hired (Required)",
    Custom: "Other type",
    Test: "Testing",
    Interview: "Interview",
    Review: "Review",
    Offers: "Offers",
    References: "References",
  },
  workFromHome: {
    AllWeek: "All week",
    FourDays: "4 days a week",
    ThreeDays: "3 days a week",
    TwoDays: "2 days a week",
    OneDay: "1 day a week",
    No: "No",
  },
  skillPrios: {
    1: "Not important",
    2: "A little important",
    3: "In between",
    4: "Very important",
    5: "Its a must have!",
  },
  dateStrings: {
    yesterday: "Yesterday",
    tomorrow: "Tomorrow",
    today: "Today",
    lastWeekFormat: "[Last] dddd",
  },
  laneNames: {
    Inkorg: "Sourced",
    Granskning: "Matches",
    Anställd: "Hired",
  },
  numberOfYearsEducation: "{years} yr ({points} ECTS)",
  IndependentCourses: "Independent Courses",
  skillpicker: {
    preItemHint: "Search or pick a recommended skill",
    addSkill: "Add skill",
    searchToFindMoreSkills: "Search to find more skills",
  },
  responsibilities: {
    personel: "Staff",
    personelLong: "Staff responsibility",
    personelDescription: "Setting salaries, performance appraisals, etc.",
    project: "Project",
    projectLong: "Project responsibility",
    projectDescription: "Managing projects from A to Z",
    sales: "Budget",
    salesLong: "Budget responsibility",
    salesDescription:
      "Responsibility for revenue and/or costs for e.g. a department, an office, a market, a division or similar.",
  },
  other: {
    internDescription:
      "The employment is of the nature Internship, Part-time, Thesis, Summer job or similar and is not included in the total work experience.",
    notRegisteredWorkYearsDescription:
      "Additional qualified full-time employment:",
  },
  sourcing: {
    reqStrings: {
      tasks: "Worked with {taskName}",
      skills: "Worked with {skillName}",
      salary:
        "Does not require a higher compensation than {totalSalary} {currency}",
      variableCompensationRequirement:
        "where at least {variableCompensation} {currency} can be variable",
      responsibilityStaff:
        "Staff responsibility | Staff responsibility | Staff responsibility for more than {minAmount} people",
      responsibilityProject:
        "Project responsibility | Project responsibility | Project responsibility for more than {minAmount} Mkr",
      responsibilityBudget:
        "Budget responsibility | Budget responsibility | Budget responsibility for more than {minAmount} Mkr",
      language: "Can handle the language: {languageText}",
      branchNew:
        "Some experience in the industry {branchText} | At least one year of experience in the industry {branchText} | At least {years} years of experience in the industry {branchText}",
      yearOfExperienceReq:
        "Has at least one year of work experience | Have at least {yearsOfWorkExperience} years of work experience",
      maxYearOfExperienceReq:
        "Has a maximum of 1 year of work experience | Has a maximum of {yearsOfWorkExperience} years of work experience",
      educationDomain: "Have studied {domainText}",
      educationLevel:
        "Have studied for at least one year | Have studied at least {years} years",
      school: "Studied at {schoolName}",
    },
  },
  common: {
    year: "year | years",
    save: "Save",
    changeLanguage: "Byt språk",
    poolCandidateNamePrefix: "Candidate",
  },
  notificationTexts: {
    MessageFromTalent:
      "A candidate has written to you in the job {recruitmentTitle}",
    TalentInterested:
      "A candidate has shown interest in the job {recruitmentTitle}",
    TalentDeclined:
      "A candidate has unfortunately declined the job {recruitmentTitle}",
    TalentAccepted:
      "A candidate has accepted the contact request for job {recruitmentTitle}",
    TagOnTalent:
      "You have been tagged in a comment on the candidate {talentName}",
    TagOnRecruitment:
      "You have been tagged in a comment on job {recruitmentTitle}",
    CommentOnSharedTalent:
      "A colleague has written to you in the job {recruitmentTitle}",
    PoolMessageFromTalent:
      "The talent {talentName} has written to you in the candidate pool",
    PoolTeamComment: "You have been mentioned in a note in the candidate pool!",
  },
  recruitmentStatsColumns: {
    "Intresserade, ej hanterade": "New matches",
    "Aktiva kandidater": "Active candidates",
    "Obesvarade möjligheter": "Unanswered opportunities",
  },
  completionListItemTexts: {
    EMPLOYMENTS: "Work experience",
    TASKS: "Tasks",
    SKILLS: "Skills",
    EDUCATION: "Education",
    LANGUAGES: "Languages",
  },
  "Kandidaten är nu sparad!": "The candidate is now saved!",
  "Kandidaten är nu inbjuden!": "The candidate is now invited!",
  Språk: "Language",
  Anonym: "Anonymous",
  $vuetify: {
    close: "Close",
    rating: {
      ariaLabel: {
        icon: "icon",
      },
    },
    dataIterator: {
      pageText: "{0}-{1} of {2}",
      noResultsText: "No matching records found",
      loadingText: "Loading items...",
    },
    dataTable: {
      itemsPerPageText: "Rows per page:",
      ariaLabel: {
        sortDescending: ": Sorted descending. Activate to remove sorting.",
        sortAscending: ": Sorted ascending. Activate to sort descending.",
        sortNone: ": Not sorted. Activate to sort ascending.",
      },
      sortBy: "Sort by",
    },
    dataFooter: {
      itemsPerPageText: "Items per page:",
      itemsPerPageAll: "All",
      nextPage: "Next page",
      prevPage: "Previous page",
      firstPage: "First page",
      lastPage: "Last page",
    },
    datePicker: {
      itemsSelected: "{0} selected",
      prevYearAriaLabel: "prev year",
      nextYearAriaLabel: "next year",
    },
    noDataText: "No data available",
    carousel: {
      prev: "Previous visual",
      next: "Next visual",
      ariaLabel: {
        delimiter: "delimiter",
      },
    },
    calendar: {
      moreEvents: "{0} more",
    },
  },
};
